/** Supported UI locales and browser-language detection (no store imports — safe to use anywhere) */

export const LOCALES = ['en', 'vi'] as const

export type Locale = (typeof LOCALES)[number]

export const DEFAULT_LOCALE: Locale = 'en'

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value)
}

/** Map a BCP 47 language tag (e.g. navigator.language) to a supported locale: vi* → vi, else en */
export function detectLocale(language: string | null | undefined): Locale {
  return language?.toLowerCase().startsWith('vi') ? 'vi' : DEFAULT_LOCALE
}

/** Locale detected from the browser, falling back to the default outside a browser */
export function detectBrowserLocale(): Locale {
  return detectLocale(typeof navigator !== 'undefined' ? navigator.language : undefined)
}
